import { assetType, } from "../../constants";

export const getShopVisitListApi = (assetSlug, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/shop-visit/asset/${assetSlug}/${queryString ? `?${queryString}` : ""}`;
};
export const getMajorAssemblyApi = (params) => {
    return `console/${params?.leaseSlug}/major-assembly`;
}
export const getMaintenanceEventApi = (assetType,assetId) => {
    return `config/maintenance-checks/${assetType}/${assetId}/?is_sv=true`;
}
export const getEngineLLPApi = (assetType,assetSlug) => {
    return `console/asset/${assetType}/${assetSlug}/llp/?for_reserve_account=module&is_llp_replacement=true&with_id=true`;
}

export const getConsantApi = () => {
    return `lease/constants/get_by_constant_types`;
}
export const addShopVisitApi = (assetSlug,leaseSlug) => {
    const queryString = new URLSearchParams({lease_slug :leaseSlug}).toString();
    return `lease/shop-visit/asset/${assetSlug}/${queryString ? `?${queryString}` : ""}`;
};
export const updateShopVisitApi = (shopVisitSlug,leaseSlug) => {
    const queryString = new URLSearchParams({lease_slug :leaseSlug}).toString();
    return `lease/shop-visit/${shopVisitSlug}/${queryString ? `?${queryString}` : ""}`;
};

export const deleteShopvisitApi = (assetSlug) => {
    return `/lease/shop-visit/asset/${assetSlug}/`;
};

export const shopVisitFileUploadPostApi = (shopVisitSlug) => {
    return `lease/shop-visit/${shopVisitSlug}/attachments`;
};

export const getShopVisitApi = (shopvisitSlug)=>{
    return `lease/shop-visit/${shopvisitSlug}/`;
}
export const sendWorkscopeApprovalApi = ()=>{
    return `lease/shop-visit/send-workscope-approval/`;
}
export const shopVisitstatusUpdateApi = (shopvisitSlug)=>{
    return `lease/shop-visit/update-status/${shopvisitSlug}/`;
}
export const sendShopVisitApprovalApi = ()=>{
    return `lease/shop-visit/send-shopvisit-approval/`;
}
export const getShopVisitStatusTimelineApi = (shopvisitSlug)=>{
    return `lease/shop-visit/status_time_line/${shopvisitSlug}/`;
}
export const getShopVisitUserApi = ()=>{
    return `console/shop_visit/user_dropdown/`;
}

export const getClaimListApi = (params, assetData,query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/claim/${assetData?.asset_type}/asset/${assetData?.asset_slug}/${queryString ? `?${queryString}` : ""}`;
};

export const addClaimApi = (params,assetData) => {
    return `lease/${params?.leaseSlug}/claim/${assetData?.asset_type}/asset/${assetData?.asset_slug}/`;
};
export const updateClaimApi = (params) => {
    return `lease/${params?.leaseSlug}/claim/`;
};

export const deleteClaimApi = (params,assetData) => {
    return `lease/${params?.leaseSlug}/claim/${assetData?.asset_type}/asset/${assetData?.asset_slug}/`;
};
export const claimFileUploadPostApi = (claimSlug) => {
    return `lease/shop-visit-claim/${claimSlug}/attachments`;
};

export const sendClaimApprovalApi = (params)=>{
    return `lease/${params?.leaseSlug}/claim/send-claim-approval/`;
}
export const claimStatusUpdateApi = (params,claimSlug)=>{
    return `lease/${params?.leaseSlug}/claim/update-status/${claimSlug}/`;
}

export const getClaimTimelineApi = (params,claimSlug)=>{
    return `lease/${params?.leaseSlug}/claim/status_time_line/${claimSlug}/`;
}

export const getLllpListApi = (shopvisitSlug, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/shop-visit/${shopvisitSlug}/engine-llps${queryString ? `?${queryString}` : ""}`;
};

export const getAddLllpListApi = (engineId, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `console/${engineId}/engine-llps${queryString ? `?${queryString}` : ""}`;
};

export const addLlpApi = (engineId) => {
    return `lease/shop-visit/${engineId}/engine-llps`;
};
export const updateLlpApi = (engineId) => {
    return `lease/shop-visit/${engineId}/engine-llps`;
};
export const deleteLlpApi = (engineId) => {
    return `lease/shop-visit/${engineId}/engine-llps`;
};

export const workscopeApi = (shopVisitSlug)=>{
    return `lease/shop-visit/${shopVisitSlug}/workscope`
}

export const getShopVisitFundBalanceApi = (shopVisit)=>{   
    return `lease/asset-type/${shopVisit?.major_assembly?.asset_type && assetType[shopVisit?.major_assembly?.asset_type]}/asset/${shopVisit?.major_assembly?.asset_slug}/shopvisit/${shopVisit?.id}/cashflow-card/`;
}

export const addEditPayoutApi = (params)=>{
    return `lease/${params?.leaseSlug}/claim/`;
}
export const verifyAmountApi = (params,assetTypeId,assetSlug,claimId) => {
    return `lease/${params?.leaseSlug}/claim/${assetType[assetTypeId]}/asset/${assetSlug}/claims/${claimId}/claim-amount-approval/`;
};
export const updateAsOfDateApi = (shopVisitSlug)=>{
    return `lease/shop-visit/update-as-of-date/${shopVisitSlug}/`
}
